import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-google-maps-input',
  templateUrl: './google-maps-input.component.html',
  styleUrls: ['./google-maps-input.component.css'],
})
export class GoogleMapsInputComponent implements OnInit {
  @Input() direction: string = '';
  @Output() selectedDirection = new EventEmitter<string>();
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  private autocomplete: google.maps.places.Autocomplete | undefined;

  map!: google.maps.Map;
  marker!: google.maps.Marker;

  ngOnInit(): void {
    console.log(this.direction);
  }

  initializeAutocomplete() {
    console.log(this.searchInput);
    const loader = new Loader({
      apiKey: environment.googleApiKey,
      libraries: ['places'],
    });

    loader.load().then(() => {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.searchInput.nativeElement,
        {
          componentRestrictions: { country: 'co' },
          types: [],
          fields: ['formatted_address', 'geometry', 'name'],
          strictBounds: false,
        }
      );

      this.autocomplete.addListener('place_changed', () => {
        const place = this.autocomplete?.getPlace();
        console.log('Lugar seleccionado:', place);

        if (place && place.formatted_address) {
          this.selectedDirection.emit(place.formatted_address);
        }

        if (place) {
          if (!place.geometry || !place.geometry.location) {
            return;
          }

          const location = place.geometry.location;
          this.showMap(location);
        }
      });
    });
  }

  showMap(location: google.maps.LatLng | google.maps.LatLngLiteral): void {
    const mapElement = document.getElementById('map');
    if (!mapElement) return;

    if (!this.map) {
      this.map = new google.maps.Map(mapElement, {
        center: location,
        zoom: 15,
        disableDefaultUI: true,
        gestureHandling: 'none',
        clickableIcons: false,
        draggable: false,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      });
    } else {
      this.map.setCenter(location);
    }

    if (!this.marker) {
      this.marker = new google.maps.Marker({
        position: location,
        map: this.map,
        cursor: 'default',
      });
    } else {
      this.marker.setPosition(location);
    }
  }
}
